$(function(){
	$(".image-icon-list").each(function(){
        var bgcolor = $(this).data("background-color");
        $(this).find('.image-icon-list__icon').css('backgroundColor', bgcolor);
        $(this).find('.image-icon-list__list svg').css('fill', bgcolor);
    })
});

